import { render } from "./AddProduct.vue?vue&type=template&id=699c2f85&scoped=true&ts=true"
import script from "./AddProduct.vue?vue&type=script&lang=ts"
export * from "./AddProduct.vue?vue&type=script&lang=ts"

import "./AddProduct.vue?vue&type=style&index=0&id=699c2f85&lang=css"
import "./AddProduct.vue?vue&type=style&index=1&id=699c2f85&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Muhammad Sohail\\Herd\\yellowrockshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-699c2f85"]])

export default __exports__